var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loadingOverlay",attrs:{"id":"loading"}},[_c('div',{staticClass:"overlay"}),_c('lottie',{attrs:{"id":"bm-loading","options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}}),_c('span')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }